import React, { PureComponent } from 'react'
import { Button} from 'antd'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { getQueryString } from '../../utils/tool'

@observer
class Home extends PureComponent {
	@observable rstCode = ''
	@observable mbrCode = ''
	@observable effDt = ''
	@observable exfDt = ''
	@observable sts = ''

	componentDidMount(){
		this.rstCode = getQueryString(this.props.history.location.search,'rstCode')
		this.mbrCode = getQueryString(this.props.history.location.search,'mbrCode')
		this.effDt = getQueryString(this.props.history.location.search,'effDt')
		this.exfDt = getQueryString(this.props.history.location.search,'exfDt')
		this.sts = getQueryString(this.props.history.location.search,'sts')
	}

	render() {
		const { rstCode,mbrCode,effDt,exfDt,sts} = this
		return (
			<div className="page_content">
				<div className='status'>当前状态：{rstCode === '0' ?'成功':'失败'}</div>
				<div className='info'>存管系统用户编号：{mbrCode}</div>
				<div className='info'>授权状态:{sts === '1' ?'已授权':'取消授权'}</div>
				<div className='info'>生效日期：{effDt}</div>
				<div className='info'>失效日期：{exfDt}</div>
				<div style={{textAlign:'center'}}>
					<Button type='primary' className='btn' onClick={()=>this.props.history.push(`/home`)}>返回首页</Button>
				</div>
			</div>
		)
	}
}
export default Home
